


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCAhFvhpfT-pMzYl8-swNB28NuaiqGn8Uo",
  authDomain: "ray-ban-opticians.firebaseapp.com",
  projectId: "ray-ban-opticians",
  storageBucket: "ray-ban-opticians.firebasestorage.app",
  messagingSenderId: "651520516545",
  appId: "1:651520516545:web:61d57f236bd0fcda09cf40"
};


// const firebaseConfig = {
//   apiKey: "AIzaSyCp_IMtSZ-pOdSrp8VNjUFrFXPT_GsW-7Q",
//   authDomain: "rayban-fb96c.firebaseapp.com",
//   projectId: "rayban-fb96c",
//   storageBucket: "rayban-fb96c.firebasestorage.app",
//   messagingSenderId: "466197939613",
//   appId: "1:466197939613:web:66c5e23e56119e54695b74"
// };


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export